/* unplugin-vue-components disabled */import { render } from "./ContactUs.vue?vue&type=template&id=60e0cd3d&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/liyankai6/Documents/project/print-open/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__